import InputDropdownTrigger from "@/components/input-dropdown-trigger";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { DropdownMenuCheckboxItemProps } from "@radix-ui/react-dropdown-menu";
import { FC } from "react";

type Checked = DropdownMenuCheckboxItemProps["checked"];

export type CheckboxFilterItem = {
  id: string;
  value: string;
  checked: Checked;
  enabled?: boolean;
};

type CheckboxFilterProps = {
  label: string;
  items: CheckboxFilterItem[];
  title?: string;
  onOpenChange?: (isOpen: boolean, items: CheckboxFilterItem[]) => void;
  onCheckedChange?: (
    item: CheckboxFilterItem,
    items: CheckboxFilterItem[],
  ) => void;
};

const CheckboxFilter: FC<CheckboxFilterProps> = (props) => {
  // Defines if the filter has at least one checked item
  const isActive = props.items.some((item) => item.checked);

  const handleCheckedChange = (changedItem: CheckboxFilterItem) => {
    const updatedItems = props.items.map((item) =>
      item.id === changedItem.id ? changedItem : item,
    );

    props.onCheckedChange?.(changedItem, updatedItems);
  };

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      props.onOpenChange?.(isOpen, props.items);
    }
  };

  return (
    <DropdownMenu onOpenChange={handleOpenChange}>
      <DropdownMenuTrigger disabled={props.items.length === 0} asChild>
        <InputDropdownTrigger
          label={props.label}
          className={cn(
            isActive &&
              "border-none bg-primary text-primary-foreground hover:bg-primary/90",
          )}
          disabled={props.items.length === 0}
        />
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-56">
        {props.title && (
          <>
            <DropdownMenuLabel>{props.title}</DropdownMenuLabel>
            <DropdownMenuSeparator />
          </>
        )}

        {props.items.map((item) => (
          <DropdownMenuCheckboxItem
            key={item.id}
            checked={item.checked}
            onCheckedChange={(checked) => {
              handleCheckedChange({ ...item, checked });
            }}
            disabled={item.enabled === undefined ? false : !item.enabled}
            onSelect={(e) => e.preventDefault()}
          >
            {item.value}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CheckboxFilter;
